import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useStore, useToast, usePopup, usePage, useAuth } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_BLL_SEND_LIST, SF_BLL_SEND_SRCH } from "./services/OsciBllRgService"; // 서비스
import dayjs from "dayjs";

/*
 * Bill Send Data List
 * !== 고지 송신 목록 ==!
 */
export const OSCI0406001Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const auth = useAuth();

    useResource({
        defaultSchema: [{ area: "cstmCd" }, { area: "coCd" }, { area: "bnkCd" }, { area: "comnCd", comnCd: "OSC0075" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Send Data List Search Form !== 고지 송신 목록 검색 폼 ==!
        bllSendSrch: useForm({
            defaultSchema: SF_BLL_SEND_SRCH,
            defaultValues: {
                cstmOfceCd: auth.get("cstmCd"),
                strtDt: comnUtils.getDate({ d: -7 }),
                endDt: comnUtils.getDate(),
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Send Data List Grid !== 고지 송신 목록 그리드 ==!
        bllSendList: useGrid({
            defaultSchema: SG_BLL_SEND_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Send List !== 고지 전송 목록 조회 ==!
        getBllSendList: useFetch({
            api: (page = grid.bllSendList.page) => {
                return APIS.getBllSendList(form.bllSendSrch.getValues(), page, grid.bllSendList.size);
            },
            enabled: comnUtils.isEmpty(form.bllSendSrch.errors) && form.bllSendSrch.isSubmitted,
            key: [grid.bllSendList.page, grid.bllSendList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.bllSendSrch.getValues(),
                    page: grid.bllSendList.page,
                    size: grid.bllSendList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Bill Send List !== 고지 전송 목록 조회 ==!
        getBllSendList: () => {
            form.bllSendSrch.handleSubmit(
                (data) => {
                    grid.bllSendList.setPage(0);
                    fetch.getBllSendList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_bllSendList: {
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }}>
                            <Link
                                to=""
                                onClick={() => {
                                    let nBllMgmtId = `${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`;
                                    popupFunc.openBllPopup(nBllMgmtId); // 고지정보 조회 팝업
                                }}
                            >{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
                tansadNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        rowValues.reffKeyTpCd == "T" && (
                            <span style={{ color: "blue" }}>
                                <Link
                                    to=""
                                    onClick={() => {
                                        popupFunc.openTansadPopup(`${rowValues.tansadNo}`); // TANSAD정보 조회 팝업
                                    }}
                                >{`${rowValues.tansadNo}`}</Link>
                            </span>
                        )
                    );
                },
                txprTin: (props: any) => {
                    const { rowValues } = props;
                    return `[${rowValues.txprTin}] ${rowValues.txprNm}`;
                },
            },
        },
    };

    // 팝업 호출
    const popupFunc = {
        // 고지 팝업
        openBllPopup: (bllNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0401002q}/${bllNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
        // TANSAD 팝업
        openTansadPopup: (tansadNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0202002q}/${tansadNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getBllSendList();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>{<Group.Control {...form.bllSendSrch.schema.sendDt}></Group.Control>}</Group.Row>
                            <Group.Row>
                                <Group.Label label={"L_BLL_NO"} />
                                <Group.Col>
                                    {/* 고지번호 */}
                                    <Group.Control
                                        {...form.bllSendSrch.schema.bllTpCd}
                                        onPaste={(e: any) => {
                                            e.preventDefault();
                                            const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                            form.bllSendSrch.setValue("bllTpCd", data.substring(0, 1));
                                            form.bllSendSrch.setValue("bllSysmCd", data.substring(1, 5));
                                            form.bllSendSrch.setValue("bllYy", data.substring(5, 7));
                                            form.bllSendSrch.setValue("bllSrno", data.substring(7, 14));
                                            form.bllSendSrch.setValue("bllDgr", data.substring(14, 15));
                                        }}
                                    />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSendSrch.schema.bllSysmCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSendSrch.schema.bllYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSendSrch.schema.bllSrno} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSendSrch.schema.bllDgr} />
                                </Group.Col>

                                <Group.Label label={"L_TANSAD_NO"} />
                                <Group.Col>
                                    {/* TANSAD번호 */}
                                    <Group.Control
                                        {...form.bllSendSrch.schema.tansadCstmOfceCd}
                                        onPaste={(e: any) => {
                                            e.preventDefault();
                                            const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                            form.bllSendSrch.setValue("tansadCstmOfceCd", data.substring(0, 4));
                                            form.bllSendSrch.setValue("tansadYy", data.substring(4, 6));
                                            form.bllSendSrch.setValue("tansadSrno", data.substring(6, 13));
                                        }}
                                    ></Group.Control>
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSendSrch.schema.tansadYy}></Group.Control>
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSendSrch.schema.tansadSrno}></Group.Control>
                                </Group.Col>
                            </Group.Row>
                            <Group.Row>
                                {<Group.Control {...form.bllSendSrch.schema.sendStts}></Group.Control>}
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllSendSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllSendList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Button
                        role="excelDown"
                        onClick={() => {
                            grid.bllSendList.exportExcel({
                                /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,

                                /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                sheetName: "Sheet Name",
                            });
                        }}
                    ></Button>

                    <Group.Section>
                        <Grid
                            {...grid.bllSendList.grid}
                            data={fetch.getBllSendList.data?.bllSendList}
                            render={render.grid_bllSendList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
